import React from 'react';
import { CheckIcon, XIcon } from 'lucide-react';
import { comparisonRows, differenceStats } from '../data/content';
import { Reveal } from './Reveal';
import { SectionHeading } from './SectionHeading';
import { StatNumber } from './StatNumber';
export function Difference() {
  return <section className="w-full bg-bone px-5 py-20 sm:py-28" data-id="element-47" data-mp="58z49v7m0e9k">
      <div className="mx-auto max-w-6xl" data-id="element-48" data-mp="57ec2c8rp7ev">
        <SectionHeading eyebrow="La diferencia del Kit" title={<>
              De docente agotado a{' '}
              <span className="text-brand" data-id="element-50" data-mp="3rgpay8k1tpkd">referente indiscutido</span>
            </>} subtitle="Dale a tus clases una estructura profesional, a tus alumnos las ganas de hablar en inglés y a ti el tiempo de volver a disfrutar la docencia." data-id="element-49" data-mp="3mhm6oqbw7ndg" />

        <Reveal delay={0.06} data-id="element-51" data-mp="3ig0w5bmtzl6f">
          <dl className="mx-auto mt-14 grid max-w-4xl grid-cols-1 overflow-hidden rounded-2xl border-2 border-ink bg-white sm:grid-cols-3" data-id="element-52" data-mp="1bpb6c7djygaf">
            {differenceStats.map((stat, index) => <div key={stat.label} className={`px-6 py-8 text-center ${index > 0 ? 'border-t-2 border-ink sm:border-l-2 sm:border-t-0' : ''}`} data-id="element-53" data-mp="1gmbc0h6hph10" data-mpi={index}>
                <dt className="sr-only" data-id="element-54" data-mp="1fadd3ewbt2g7">{stat.label}</dt>
                <dd data-id="element-55" data-mp="1f7hbngl9rvn0">
                  <StatNumber value={stat.value} prefix={stat.prefix} suffix={stat.suffix} className="block font-display text-5xl leading-none text-brand" data-id="element-56" data-mp="1t0p75jch1b9z" />
                  <span className="mx-auto mt-4 block max-w-[14rem] text-sm font-semibold leading-snug text-ink/70" data-id="element-57" data-mp="1o2f82xnmlqj3">
                    {stat.label}
                  </span>
                </dd>
              </div>)}
          </dl>
        </Reveal>

        <Reveal delay={0.08} data-id="element-58" data-mp="1aa7ipqyo91uf">
          <h3 className="mt-20 text-center font-display text-2xl leading-tight text-ink sm:text-4xl" data-id="element-59" data-mp="1abihfcd9fjeo">
            El costo de improvisar <span className="text-ink/35" data-id="element-60" data-mp="15a2zvuaajv11">vs.</span>{' '}
            <span className="text-brand" data-id="element-61" data-mp="2lout29f9h6be">el sistema definitivo</span>
          </h3>
        </Reveal>

        <div className="mt-10 overflow-hidden rounded-3xl border-2 border-ink bg-white shadow-lift" data-id="element-62" data-mp="2grch0a5y6az6">
          <div className="grid grid-cols-1 border-b-2 border-ink md:grid-cols-2" data-id="element-63" data-mp="2os0kke24xivt">
            <div className="flex items-center gap-3 bg-bone px-6 py-5 md:border-r-2 md:border-ink" data-id="element-64" data-mp="2ssb2mp37bzr1">
              <span className="inline-flex h-8 w-8 items-center justify-center rounded-full bg-ink/10 text-ink/60" data-id="element-65" data-mp="2xrfbfem7rvgu">
                <XIcon className="h-4 w-4" aria-hidden="true" strokeWidth={3} data-id="element-66" data-mp="32pyy5h8mtba9" />
              </span>
              <span className="font-display text-lg text-ink/55" data-id="element-67" data-mp="254b1cv89kqy7">
                Antes de INGLES LISTO
              </span>
            </div>
            <div className="flex items-center gap-3 bg-ink px-6 py-5" data-id="element-68" data-mp="2a09x53vx9b8n">
              <span className="inline-flex h-8 w-8 items-center justify-center rounded-full bg-volt text-ink" data-id="element-69" data-mp="2f0nv1t3t74sy">
                <CheckIcon className="h-4 w-4" aria-hidden="true" strokeWidth={3} data-id="element-70" data-mp="2jtgxubfpw32e" />
              </span>
              <span className="font-display text-lg text-white" data-id="element-71" data-mp="1mci8r1x3x7r0">
                Con el Kit INGLES LISTO™
              </span>
            </div>
          </div>

          <ul data-id="element-72" data-mp="1jslwqnd3lyis">
            {comparisonRows.map((row, index) => <li key={row.beforeTitle} className={`grid grid-cols-1 md:grid-cols-2 ${index > 0 ? 'border-t-2 border-ink/10' : ''}`} data-id="element-73" data-mp="1jq9d85rozg3m" data-mpi={index}>
                <Reveal delay={index * 0.03} className="border-b border-ink/10 bg-white px-6 py-6 md:border-b-0 md:border-r-2 md:border-ink/10 md:px-8" data-id="element-74" data-mp="19tmv3oqr335a">
                  <p className="font-display text-base text-ink/50" data-id="element-75" data-mp="14x5x82tr1af0">
                    {row.beforeTitle}
                  </p>
                  <p className="mt-2 text-base leading-relaxed text-ink/60" data-id="element-76" data-mp="w31btyxdwr6v">
                    {row.beforeText}
                  </p>
                </Reveal>
                <Reveal delay={index * 0.03 + 0.03} className="bg-brand-light/40 px-6 py-6 md:px-8" data-id="element-77" data-mp="r3y5mb5o4exb">
                  <p className="font-display text-base text-brand-dark" data-id="element-78" data-mp="m6eql915by4b">
                    {row.afterTitle}
                  </p>
                  <p className="mt-2 text-base font-medium leading-relaxed text-ink/80" data-id="element-79" data-mp="d3vows93jrjn">
                    {row.afterText}
                  </p>
                </Reveal>
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}